export function persianToEnglishNumber(persianNum: string) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let result = persianNum;
    for (let i = 0; i < persianDigits.length; i++) {
        result = result.split(persianDigits[i]).join(englishDigits[i]);
    }
    return result;
}